///<reference path='../typings/index.d.ts' />
///<reference path='manifest/assets.ts' />
///<reference path='controller/piximenucontroller.ts' />
///<reference path='layer/gamescene.ts' />

module agi.expressions.card {
    import EventBus           = agi.expressions.event.EventBus;
    import Event              = agi.expressions.event.Event;
    import AssetManifest      = agi.expressions.card.manifest.AssetManifest;
    import PIXIMenuController = agi.expressions.card.controller.PIXIMenuController;
    import GameScene          = agi.expressions.card.layer.GameScene;

    export enum Scenes {SCENE_ONE};
    
    export class SceneOptions{
        public transition:Scenes;
        public scale:number;
        public personalizations:any;
        public renderer:PIXI.CanvasRenderer|PIXI.WebGLRenderer;
        public assetManifest:AssetManifest;
    }

    export class SceneManager{
        public container:HTMLElement;
        public pixiContainer:PIXI.Container;
        public measuringContainer:HTMLElement;
        public currentScene:Scenes = Scenes.SCENE_ONE;
        private assetManifest:AssetManifest;
        private personalizations:any = {};
        private isPlaying:boolean = false;

        private eventBus:EventBus = EventBus.getInstance();
        private options:SceneOptions = new SceneOptions();
        private mode:Mode = Mode.Sender;
        private hasReset:boolean = false;
        private menuController:PIXIMenuController;

        public gameScene:GameScene;

        constructor(container:HTMLElement, pixiContainer:PIXI.Container, 
            measuringContainer:HTMLElement, personalizations:any, 
            assetManifest:AssetManifest, mode:Mode){
                this.container = container;
                this.pixiContainer = pixiContainer;
                this.measuringContainer = measuringContainer;
                this.personalizations = personalizations;
                this.assetManifest = assetManifest;
                this.mode = mode;
        }

        public init(renderer:PIXI.WebGLRenderer|PIXI.CanvasRenderer):void {
            this.options.renderer = renderer;
            this.options.scale = 1;
            this.options.transition = Scenes.SCENE_ONE;
            this.options.personalizations = this.personalizations;
            this.options.assetManifest = this.assetManifest;

            this.gameScene = new GameScene();
            this.gameScene.init(this.options);

            this.pixiContainer.addChild(this.gameScene);

            /*
            if (!Config.IS_DESKTOP_VIEW){
                this.menuController = new PIXIMenuController(
                    this.assetManifest,
                    renderer
                );
                this.menuController.init(this.pixiContainer);
                this.menuController.createLoaderDiv(this.container);
            }

            if (this.mode === Mode.Sender){
                this.eventBus.addEventListener("reset", this.reset.bind(this));
                renderer.view.style.display = "none";
                if (this.menuController){
                    this.menuController.showSend();
                }
            }
            */
            this.startRecieverScene();
            this.eventBus.addEventListener("replay", this.replay.bind(this));
        }
        
        public animate(deltaTime:number):void{
            if(!this.isPlaying){
                this.isPlaying = true;
            }else{
                //Animate
                this.gameScene.animate(deltaTime);
            }
        }

        public transition(scene:Scenes):void {
        }

        public resize(event) {
        }

        public reset(){
            this.options.renderer.view.style.display = "none";
            this.dispatchShouldAnimate(false);
            this.hasReset = true;
            this.gameScene.reset();
        }

        public replay(){
        }
        
        protected replayForReceiver(evnet:any){
            if (this.mode !== Mode.Sender){
                this.replay();
            }
        }

        protected startRecieverScene() {
            this.dispatchShouldAnimate(true);
            this.options.renderer.view.style.display = "block";

            if (!this.hasReset) {
                this.setupReceiverScene();
            }
            else {
                this.resetReceiverScene();
            }
            this.dispatchSetPersEvent();
        }

        protected setupReceiverScene(){
        }

        protected resetReceiverScene(){
            this.replay();
        }

        protected dispatchSetPersEvent(){
            if (this.mode === Mode.Sender){
                var persEvent = new Event("setPers", this);
                this.eventBus.dispatchEvent(persEvent);
            }
        }

        protected dispatchShouldAnimate(value:boolean){
            var event:any = new Event("shouldAnimate", this);
            event.shouldAnimate = value;
            this.eventBus.dispatchEvent(event);
        }
    }
}